import { httpReducer, reduceReducers } from "../lib/create-action";
import {
  GET_CAMPAIGN,
  CREATE_CAMPAIGN_ITEM,
  UPDATE_CAMPAIGN_ITEM,
} from "../action_managers/campaigns";
import {
  FETCH_SHOW_CAMPAIGN_ACTION,
  FETCH_SHOW_CAMPAIGNS_ACTION,
  RESPOND_TO_CAMPAIGN_OFFER_ACTION,
} from "../actions/campaigns";
import keyBy from "lodash/keyBy";
import get from "lodash/get";
import union from "lodash/union";

const initialState = {
  isLoading: false,
  //TODO: merge these two in the components
  campaignItems: {},
  campaignItemByUUID: {},

  // showUUID --> [campaignItem1UUID, campaignItem2UUID ...]
  showCampaignItemUUIDs: {},
};

const getCampaigns = httpReducer(GET_CAMPAIGN, initialState, {
  success: (state, action) => ({
    ...state,
    campaignItems: { ...state.campaignItems, ...keyBy(action.payload.resp.items, "item.uuid") },
  }),
});

const createCampaignItem = httpReducer(CREATE_CAMPAIGN_ITEM, initialState, {
  success: (state, action) => ({
    ...state,
    campaignItems: { ...state.campaignItems, ...keyBy(action.payload.resp) },
  }),
});

const getShowCampaignItem = httpReducer(FETCH_SHOW_CAMPAIGN_ACTION, initialState, {
  success: (state, action) => {
    const resp = action.payload.resp;
    const campaignItem = resp.campaignItem;
    const showUUID = get(action, ["data", "showUUID"]);

    const campaignItemByUUID = {
      ...state.campaignItemByUUID,
      [campaignItem.uuid]: campaignItem,
    };

    const showCampaignItemUUIDs = {
      ...state.showCampaignItemUUIDs,
      [showUUID]: union([campaignItem.uuid], get(state.showCampaignItemUUIDs, showUUID, [])),
    };

    return {
      ...state,
      campaignItemByUUID,
      showCampaignItemUUIDs,
    };
  },
});

const respondToCampaignOffer = httpReducer(RESPOND_TO_CAMPAIGN_OFFER_ACTION, initialState, {
  success: (state, action) => {
    const campaignItem = action.payload.resp;

    const campaignItemByUUID = {
      ...state.campaignItemByUUID,
      // fresh state is used to tell the rest of the app that the state just updated. has implications for podcaster campaign page
      [campaignItem.uuid]: { ...campaignItem, freshState: true },
    };

    const showCampaignItemUUIDs = {
      ...state.showCampaignItemUUIDs,
      [campaignItem.showUUID]: union(
        [campaignItem.uuid],
        state.showCampaignItemUUIDs?.[campaignItem.showUUID] ?? []
      ),
    };

    return {
      ...state,
      campaignItemByUUID,
      showCampaignItemUUIDs,
    };
  },
});

const getShowCampaignItems = httpReducer(FETCH_SHOW_CAMPAIGNS_ACTION, initialState, {
  success: (state, action) => {
    const resp = action.payload.resp;
    const campaignItems = get(resp, "campaignItems", []);
    const showUUID = get(action, ["data", "showUUID"]);

    const campaignItemByUUID = {
      ...state.campaignItemByUUID,
      ...keyBy(campaignItems, "uuid"),
    };
    const showCampaignItemUUIDs = {
      ...state.showCampaignItemUUIDs,
      [showUUID]: campaignItems.map(({ uuid }) => uuid),
    };

    return {
      ...state,
      campaignItemByUUID,
      showCampaignItemUUIDs,
    };
  },
});

const updateCampaignItems = httpReducer(UPDATE_CAMPAIGN_ITEM, initialState, {});

export default reduceReducers(
  getCampaigns,
  createCampaignItem,
  getShowCampaignItem,
  getShowCampaignItems,
  updateCampaignItems,
  respondToCampaignOffer
);
